import { render } from "./LearningModesSection.vue?vue&type=template&id=e9cd8806&scoped=true"
import script from "./LearningModesSection.vue?vue&type=script&lang=js"
export * from "./LearningModesSection.vue?vue&type=script&lang=js"

import "./LearningModesSection.vue?vue&type=style&index=0&id=e9cd8806&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9cd8806"]])

export default __exports__